import { FAutocomplete } from '../../../../../components/baseV2';
import ChevronDownIcon from '../../../../../components/svgs/ChevronDownIcon';
import { FORTA_GRAY8 } from '../../../../../utils/colors';
import { CLIENT_NAME_AUTOCOMPLETE_SX } from '../styles';

import type { HTMLAttributes } from 'react';
import type { IOption } from '../../../../../utils/types';
import type { ClientNameSelectProps } from './types';

const renderClientOption = (props: HTMLAttributes<HTMLLIElement>, option: IOption) => (
  <li {...props} key={option.id} data-testid={`clientName${option.id}`}>
    {option.label}
  </li>
);

export default function ClientNameSelect({
  value,
  options,
  disabled,
  onChange,
}: ClientNameSelectProps) {
  return (
    <FAutocomplete<IOption>
      data-testid="clientName"
      label="Client name"
      fullWidth
      placeholder="Select client"
      disabled={disabled}
      isOptionEqualToValue={(option, selected) => option.id === selected.id}
      options={options}
      renderOption={renderClientOption}
      value={value}
      onChange={onChange}
      popupIcon={<ChevronDownIcon color={FORTA_GRAY8} />}
      sx={CLIENT_NAME_AUTOCOMPLETE_SX}
    />
  );
}
